// extracted by mini-css-extract-plugin
export default {"shippingZone__name":"SelectShippingZone_shippingZone__name__psFrc"};